import { CommonModule } from '@angular/common';
import { Component, ElementRef, input } from '@angular/core';
import { IsActiveMatchOptions, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { ImageComponent } from '@sp-client/app/components/image/image.component';
import { ScrollService } from '@sp-client/app/services/scroll.service';
import { LogService } from '@sp-client/app/services/log.service';

@Component({
	selector: 'sp-tabbar',
	imports: [CommonModule, RouterLink, RouterLinkActive, ImageComponent],
	templateUrl: './tabbar.component.html',
	styleUrl: './tabbar.component.scss'
})
export class TabbarComponent {
	isIOSStandalone = input(false);
	isAndroidStandalone = input(false);

	constructor(
		private router: Router,
		private scrollService: ScrollService,
		private log: LogService
	) {}

	isDashboardActive(): boolean {
		const options: IsActiveMatchOptions = {
			paths: 'exact',
			queryParams: 'ignored',
			fragment: 'ignored',
			matrixParams: 'ignored'
		};
		return this.router.isActive('/', options);
	}

	scrollToTop() {
		this.log.debug('scroll to top');
		this.scrollService.scrollToTop({ useNativeSmooth: true });
	}

	onTabClick(path: string, event: Event) {
		if (this.router.url === path) {
			event.preventDefault(); // prevent re-navigation
			this.scrollToTop();
		}
	}
}
